import { useCallback, useEffect } from "react";

export const useScrollAnimation = (className: string = "") => {
  const reveal = useCallback(() => {
    let reveals: NodeListOf<Element>;
    if (className) {
      reveals = document.querySelectorAll(`.${className} .reveal`);
    } else {
      reveals = document.querySelectorAll(".reveal");
    }

    for (let i = 0; i < reveals?.length; i++) {
      const h = window.innerHeight;
      const elementTop = reveals[i].getBoundingClientRect().top;
      const elementVisible = 30;
      if (elementTop < h - elementVisible) {
        reveals[i].classList.add("active");
      }
    }
  }, [className]);

  const clear = useCallback(() => {
    let reveals: NodeListOf<Element>;
    if (className) {
      reveals = document.querySelectorAll(`.${className} .reveal`);
    } else {
      reveals = document.querySelectorAll(".reveal");
    }

    for (let i = 0; i < reveals?.length; i++) {
      reveals[i].classList.remove("active");
    }
  }, [className]);

  useEffect(() => {
    window.addEventListener("scroll", reveal);

    return () => {
      window.removeEventListener("scroll", reveal);
    };
  });

  return {
    reveal,
    clear,
  };
};
